/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState, useContext, useCallback } from 'react'

import { BackofficeUser } from '@types'
import { LOCAL_STORAGE_KEYS } from '@constants'

type ContextState = {
  state: BackofficeUser | undefined
  setState: (state: BackofficeUser | undefined) => void
}

const initialState = {
  state: undefined,
  setState: () => {},
}

const UserContext = React.createContext<ContextState>(initialState)

export function UserProvider({ children }: { children: React.ReactNode }) {
  const [state, setUser] = useState<BackofficeUser>(() => {
    const localUser = window.localStorage.getItem(LOCAL_STORAGE_KEYS.USER)
    if (localUser) return JSON.parse(localUser)
    return null
  })
  const setState = useCallback(updatedUser => {
    console.log('setting user')
    setUser(updatedUser)
    window.localStorage.setItem(LOCAL_STORAGE_KEYS.USER, JSON.stringify(updatedUser))
  }, [])
  return <UserContext.Provider value={{ state, setState }}>{children}</UserContext.Provider>
}

export function useUser(): ContextState {
  const context = useContext(UserContext)
  if (!context) throw Error('This hook can only be used under the UserProvider component')
  return context
}
